var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popup-mass-edit-vat-mode" },
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: true, width: "480", "custom-class": "flex-column" },
          on: {
            close: function($event) {
              return _vm.$emit("close")
            }
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _c("span", { staticClass: "fs-5 bold" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Modifier le mode de TVA")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "semibold alert alert-info mt-3" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Une fois enregistrées, les modifications peuvent prendre plusieurs secondes à s'appliquer."
                          )
                        ) +
                        "\n            "
                    )
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "span",
                    { staticClass: "dialog-footer" },
                    [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.cancel"),
                          type: "secondary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.save"),
                          type: "primary",
                          disabled: _vm.selectedLabel === ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.save()
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "div",
            _vm._l(this.prefsSelected, function(pref, key) {
              return _c(
                "div",
                { key: key },
                [
                  key >= 1 ? _c("el-divider") : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "pb-1" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$l10n.__("Mode de TVA à mettre à jour")) +
                        "\n                    "
                    ),
                    _vm.prefsSelected.length > 1
                      ? _c("i", {
                          staticClass:
                            "icon-trash fright gray-60 hover-gray-80",
                          on: {
                            click: function($event) {
                              return _vm.onRemovePref(key, pref)
                            }
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      ref: "selectVatMode",
                      refInFor: true,
                      staticClass: "wp-10",
                      attrs: {
                        placeholder: _vm.$t.__(
                          "forms.PopupMassEditVatMode.vat_mode"
                        )
                      },
                      model: {
                        value: _vm.selectedLabel,
                        callback: function($$v) {
                          _vm.selectedLabel = $$v
                        },
                        expression: "selectedLabel"
                      }
                    },
                    _vm._l(_vm.prefsForDropDown, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.label,
                          value: item.value,
                          "data-test": "vatmode"
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }